import type { CharacterId } from './api';

export type PortraitCharacter = {
  id: CharacterId;
  name: string;
  title: string;
  alt: string;
  imagePrefix: string;
  /** The painting with the sitter absent, for the leave-the-frame gag. */
  emptyPlate?: string;
};

export const CHARACTERS: Record<CharacterId, PortraitCharacter> = {
  mara: {
    id: 'mara',
    name: 'Mara Vexley',
    title: 'Experimental Alchemy · 1872–?',
    alt: 'Mara Vexley, an alchemist painted in plum and verdigris',
    imagePrefix: '/assets/portrait/mara',
    emptyPlate: '/assets/portrait/mara-empty.png',
  },
  wizard: {
    id: 'wizard',
    name: 'Professor Aldren Vale',
    title: 'Astral Philosophy · 1791–?',
    alt: 'Professor Aldren Vale, a venerable wizard painted in umber and charcoal',
    imagePrefix: '/assets/portrait/wizard',
  },
  robot: {
    id: 'robot',
    name: 'Iver Seven',
    title: 'Pilot · Northstar Alpine Line',
    alt: 'Iver Seven, a brass-and-steel locomotive pilot',
    imagePrefix: '/assets/portrait/robot',
  },
  chuck: {
    id: 'chuck',
    name: 'Chuck',
    title: 'Conductor of Conversations',
    alt: 'Chuck, a friendly guide to contact-center software',
    imagePrefix: '/assets/chuck/conductor-of-conversations',
  },
};

// Aldren hangs to Mara's left so her screen-left glance meets his portrait.
// Mara remains the initially selected character; this controls wall placement only.
export const CHARACTER_ORDER: CharacterId[] = ['wizard', 'mara'];
